import React, { useState, useMemo } from 'react';
import { Gantt, ViewMode } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";
import { Select, Space } from 'antd';
import dayjs from 'dayjs';

export default function GanttChartWrapper({ ganttData, onTaskClick, defaultViewMode = ViewMode.Day, hideControls = false }) {
  const [viewMode, setViewMode] = useState(defaultViewMode);

  const tasks = useMemo(() => {
    if (!ganttData || ganttData.length === 0) return [];
    
    return ganttData.map((item) => {
      // Fallback for missing dates
      const start = item.start_date ? new Date(item.start_date) : new Date();
      let end = item.due_date ? new Date(item.due_date) : new Date();
      
      // Gantt needs end date > start date
      if (end <= start) {
        end = new Date(start.getTime() + 24 * 60 * 60 * 1000); // add 1 day
      }

      // Check if parent exists in the data
      const parentExists = item.parent_id && ganttData.some(t => t.id === item.parent_id);

      return {
        id: String(item.id),
        type: item.has_subtasks ? 'project' : 'task',
        name: item.title || `Task ${item.id}`,
        start: start,
        end: end,
        progress: item.progress || 0,
        project: parentExists ? String(item.parent_id) : undefined,
        dependencies: item.dependencies && item.dependencies.length > 0 ? item.dependencies.map(String) : [],
        isDisabled: false,
        styles: {
          progressColor: '#1890ff',
          progressSelectedColor: '#096dd9',
        }
      };
    });
  }, [ganttData]);

  if (tasks.length === 0) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Нет данных для отображения на диаграмме Ганта или даты не указаны</div>;
  }

  return (
    <div style={{ background: '#fff', padding: '16px', borderRadius: '8px' }}>
      {!hideControls && (
        <div style={{ marginBottom: '16px' }}>
          <Space>
            <span>Масштаб:</span>
            <Select 
              value={viewMode}
              onChange={setViewMode}
              options={[
                { value: ViewMode.Day, label: 'День' },
                { value: ViewMode.Week, label: 'Неделя' },
                { value: ViewMode.Month, label: 'Месяц' },
                { value: ViewMode.Year, label: 'Год' },
              ]}
              style={{ width: 120 }}
            />
          </Space>
        </div>
      )}
      <div style={{ overflowX: hideControls ? 'visible' : 'auto' }} className="gantt-container">
        <Gantt
          tasks={tasks}
          viewMode={viewMode}
          locale="ru"
          onClick={(task) => {
            if (onTaskClick) {
              onTaskClick({ id: parseInt(task.id) }); // trigger detail view
            }
          }}
        />
      </div>
    </div>
  );
}
